// see lib_ui-components\src\components\Theme\createGlobalStyle.browser.js
// for highcharts css overrides
import 'highcharts/css/highcharts.css';
// eslint-disable-next-line import/extensions
import Chart from './Chart.js';
export default Chart;
